// Contactos da escola usados em todo o site.
// WhatsApp: formato internacional, só dígitos (351 + número).
export const WHATSAPP_NUMERO = '351914932448';

const MENSAGEM_AULA = 'Olá! Gostava de marcar uma aula experimental na HM.';

export const WHATSAPP_AULA = `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(MENSAGEM_AULA)}`;
export const INSTAGRAM = 'https://www.instagram.com/hm.escolakickboxing';
export const FACEBOOK = 'https://www.facebook.com/hugo.miguel.7773';
export const EMAIL = 'info@hmkickboxing.com';
